module.exports = __webpack_public_path__ + "assets/img/footer_logo_11.422d66a3.png";